import { render, staticRenderFns } from "./content.vue?vue&type=template&id=5b16c53a"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b16c53a')) {
      api.createRecord('5b16c53a', component.options)
    } else {
      api.reload('5b16c53a', component.options)
    }
    module.hot.accept("./content.vue?vue&type=template&id=5b16c53a", function () {
      api.rerender('5b16c53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/rights/fee/dealer_acount/content.vue"
export default component.exports